import React from "react";

function DateFilter({ uniqueDates, onDateClick, activeDate, className = "" }) {
  if (!uniqueDates || uniqueDates.length === 0) {
    return null;
  }

  // Tính số cột cần thiết (tối đa 2 cột)
  const useTwoColumns = uniqueDates.length > 10; // Nếu có hơn 10 ngày thì dùng 2 cột
  const itemsPerColumn = useTwoColumns ? Math.ceil(uniqueDates.length / 2) : uniqueDates.length;
  const firstColumnDates = uniqueDates.slice(0, itemsPerColumn);
  const secondColumnDates = useTwoColumns ? uniqueDates.slice(itemsPerColumn) : [];

  return (
    <div className={`flex gap-1.5 px-1 py-2 overflow-y-auto ${className}`} style={{ height: '100vh', width: useTwoColumns ? 'auto' : 'auto' }}>
      {/* Cột đầu tiên */}
      <div className="flex flex-col justify-end gap-1.5">
        {firstColumnDates.map((date) => {
          const isActive = activeDate && activeDate.trim() === date.trim();
          return (
            <button
              key={date}
              onClick={() => onDateClick(date)}
              className={`w-8 h-8 text-[10px] font-medium rounded flex items-center justify-center transition-colors ${
                isActive
                  ? "bg-blue-500 text-white border-2 border-blue-600 shadow-md"
                  : "text-slate-600 bg-slate-100 hover:bg-slate-200 border border-slate-300"
              }`}
              title={date}
            >
              {date.split('/')[0]}
            </button>
          );
        })}
      </div>
      {/* Cột thứ hai (nếu có) */}
      {secondColumnDates.length > 0 && (
        <div className="flex flex-col justify-end gap-1.5">
          {secondColumnDates.map((date) => {
            const isActive = activeDate && activeDate.trim() === date.trim();
            return (
              <button
                key={date}
                onClick={() => onDateClick(date)}
                className={`w-8 h-8 text-[10px] font-medium rounded flex items-center justify-center transition-colors ${
                  isActive
                    ? "bg-blue-500 text-white border-2 border-blue-600 shadow-md"
                    : "text-slate-600 bg-slate-100 hover:bg-slate-200 border border-slate-300"
                }`}
                title={date}
              >
                {date.split('/')[0]}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default DateFilter;
